import React, { useState, useRef } from 'react';
import './MarriottBonvoyApp.css';
import CurvedHeader from './CurvedHeader';
import OptimizedImage from './OptimizedImage';

import phoneImage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/iphoneMock_digitalSolutions.png';
import phoneImageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/iphoneMock_digitalSolutions.avif';
import phoneImagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/iphoneMock_digitalSolutions.webp';

import bookImage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Book.png';
import bookImageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Book.avif';
import bookImagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Book.webp';

import tripImage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Trip.png';
import tripImageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Trip.avif';
import tripImagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Trip.webp';

import accountImage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Account.png';
import accountImageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Account.avif';
import accountImagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriott_bonvoy_App_Account.webp';

const TABS = ['HOMESCREEN', 'BOOKING INTERFACE', 'TRIP SCREEN', 'ACCOUNT PORTAL'];

const TAB_IMAGES = {
  HOMESCREEN: { avif: phoneImageavif, webp: phoneImagewebp, fallback: phoneImage },
  'BOOKING INTERFACE': { avif: bookImageavif, webp: bookImagewebp, fallback: bookImage },
  'TRIP SCREEN': { avif: tripImageavif, webp: tripImagewebp, fallback: tripImage },
  'ACCOUNT PORTAL': { avif: accountImageavif, webp: accountImagewebp, fallback: accountImage },
};

export default function MarriottBonvoyApp() {
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const contentRef = useRef(null);

  const scrollToContent = () => {
    contentRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className='marriott-bonvoy-app'>
      <CurvedHeader
        title='MARRIOTT BONVOY APP'
        pills={[
          {
            textLight: '6 ad units on app home screen',
            icon: (
              <svg
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <rect x='5' y='2' width='14' height='20' rx='2' ry='2' />
                <line x1='12' y1='18' x2='12.01' y2='18' />
              </svg>
            ),
          },
        ]}
        backgroundColor='var(--bonvoy-coral)'
        titleColor='#1a1a1a'
        pillBackgroundColor='white'
        pillTextColor='#1a1a1a'
        pillIconBackgroundColor='var(--bonvoy-coral)'
        pillIconColor='white'
        arrowColor='#1a1a1a'
        onArrowClick={scrollToContent}
      />

      <div className='marriott-bonvoy-app__content-wrapper' ref={contentRef}>
        <div className='marriott-bonvoy-app__content'>
          <div className='marriott-bonvoy-app__tabs-container'>
            <div className='marriott-bonvoy-app__tabs'>
              {TABS.map((tab) => (
                <div key={tab} className='marriott-bonvoy-app__tab-wrapper'>
                  <button
                    className={`marriott-bonvoy-app__tab ${activeTab === tab ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab)}
                    onMouseEnter={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                  {activeTab === tab && (
                    <div className='marriott-bonvoy-app__tab-arrow'>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      >
                        <path d='M5 12h14' />
                        <path d='M12 5l7 7-7 7' />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className='marriott-bonvoy-app__image-container'>
            <OptimizedImage
              avif={TAB_IMAGES[activeTab].avif}
              webp={TAB_IMAGES[activeTab].webp}
              fallback={TAB_IMAGES[activeTab].fallback}
              alt={`Marriott Bonvoy App - ${activeTab}`}
            />
          </div>

          <div className='marriott-bonvoy-app__details'>
            <h3 className='marriott-bonvoy-app__details-title'>
              Stay with the <br className='desktop-only' />
              traveler as the <br className='desktop-only' />
              journey unfolds
            </h3>
            <p className='marriott-bonvoy-app__details-text'>
              It starts with a booking then moves on to check-in. Your brand appears in the moments
              that shape the experience not outside of it.
            </p>
            <div className='marriott-bonvoy-app__stats-card'>
              <h4>OVER 500 ATTRIBUTES</h4>
              <p>Targeting variables rooted in real traveler behavior</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
